// Colors
import { primary } from '../../common/colors';

export default {
  root: {
    backgroundColor: '#f8fafc',
    '&:hover': {
      backgroundColor: primary.light
    },
    '&$focused': {
      backgroundColor: primary.light
    }
  }
};
